module.exports = __webpack_public_path__ + "static/media/lock_white.775bc1db.svg";